import React from 'react';
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import FurnitureCategories from "../components/FurnitureCategories";
import "./Catalog.css";
import { Helmet } from "react-helmet";



function Catalog() {
  return (
    <>
     <Helmet>
        <title>Catalog Mobilă București - Sector 2</title>
        <meta name="description" content="Vezi catalogul nostru de mobilă la comandă în București, Sector 2. Mobilier modern și personalizat pentru casa ta." />
        <meta name="keywords" content="catalog mobila București, mobila sector 2, mobilier la comandă, mobila modernă" />
      </Helmet>
    <div className="catalog-page">
      {/* Navbar */}
      <Navbar />
      
      {/* Conținutul specific paginii */}
      <main className="catalog-main">
        <div className="catalog-header">
          <h1>Catalog Mobilier Personalizat București Sector 2</h1>
          <p>Descoperă cele mai frumoase piese de mobilier la comandă, realizate cu materiale premium și design personalizat pentru casa ta din Sectorul 2.</p>
        </div>
        
        {/* Categorii Mobilier */}
        <FurnitureCategories />
      </main>
      
      {/* Footer */}
      <Footer />
    </div>
    </>
  );
}

export default Catalog;